(()=>{
  const KEY='okd_okee_ref_v1',TTL=30*24*60*60*1000;
  const norm=v=>{const c=String(v||'').trim().toUpperCase();return /^OKEE-[A-Z0-9-]{3,59}$/.test(c)?c:''};
  const params=new URLSearchParams(location.search);
  const incoming=norm(params.get('ref'));
  let stored='';
  try{
    if(incoming)localStorage.setItem(KEY,JSON.stringify({code:incoming,at:Date.now()}));
    const raw=JSON.parse(localStorage.getItem(KEY)||'null');
    if(raw&&norm(raw.code)&&Date.now()-Number(raw.at||0)<=TTL)stored=norm(raw.code);
    else if(raw)localStorage.removeItem(KEY);
  }catch{}
  const code=incoming||stored;
  if(!code)return;
  window.OKD_OKEE_REF_CODE=code;
  const country=String(window.OKD_OKEE_COUNTRY||'').toUpperCase();
  const isMa=country==='MA'||location.hostname.toLowerCase().startsWith('ma.');
  if(isMa)return;
  const flag='okd_discount_applied_'+code;
  try{if(sessionStorage.getItem(flag)==='1')return;sessionStorage.setItem(flag,'1')}catch{}
  const clean=new URL(location.href);
  clean.searchParams.delete('ref');
  const redirect=clean.pathname+(clean.search||'')+(clean.hash||'');
  location.replace('/discount/'+encodeURIComponent(code)+'?redirect='+encodeURIComponent(redirect||'/'));
})();